import React, { useState } from "react";

import { LiaUsersCogSolid } from "react-icons/lia";
import { MdGroups2 } from "react-icons/md";
import { FaUsersBetweenLines } from "react-icons/fa6";
import VendorsGroups from "../../components/Vendors/groups/VendorsGroups";
import VendorsHome from "../../components/Vendors/VendorsHome";
import { useTranslation } from "react-i18next";
import { CardHeadeWithActions } from "../../components/ui";

const Vendors = () => {
  const [tabActive, setTabActive] = useState("vendors");
  const [t] = useTranslation("global");

  return (
    <>
      <CardHeadeWithActions>
        <div className="w-[100%] mb-0 flex justify-between items-center">
          <div className="title flex justify-center gap-1 items-center">
            <LiaUsersCogSolid size={18} />
            <span className="text-[#261759] ms-1 font-bold ">
              {t("vendors.title")}
            </span>
          </div>
        </div>
      </CardHeadeWithActions>
      <div id="Tabs" className="w-full flex mt-3 gap-2 bg-[#F8FAFC] rounded-md p-1">
        <div
          onClick={() => setTabActive("vendors")}
          className={`flex-1 flex flex-col gap-1 items-center justify-center rounded-md text-[#261759] p-3 cursor-pointer transition ${
            tabActive === "vendors"
              ? "bg-[#EBF9D9] font-bold"
              : "bg-white"
          }`}
        >
          <FaUsersBetweenLines size={28} />
          <hr />
          <span className="text-sm "> {t("vendors.vendors")} </span>
        </div>
        <div
          onClick={() => setTabActive("Groups")}
          className={`flex-1 flex flex-col gap-1 items-center justify-center rounded-md text-[#261759] p-3 cursor-pointer transition ${
            tabActive === "Groups"
              ? "bg-[#EBF9D9] font-bold"
              : "bg-white"
          }`}
        >
          <MdGroups2 size={28} />
          <hr />
          <span className="text-sm  ">{t("vendors.vendorGroups")}</span>
        </div>
      </div>
      <div className="text-[#261759] bg-[#F8FAFC] rounded-md text-xs p-3 py-5 mt-2">
        {tabActive === "vendors" && <VendorsHome />}
        {tabActive === "Groups" && <VendorsGroups />}
      </div>
    </>
  );
};

export default Vendors;
